import React, { useState, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";
import { useHistory } from "react-router";
import SideNav from "../Layout/SideNav";
import Box from "@material-ui/core/Box";
import SearchBar from "material-ui-search-bar";
import Divider from "@material-ui/core/Divider";
import {
  createStyles,
  Theme,
  makeStyles,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem, { ListItemProps } from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import Switch from "@material-ui/core/Switch";
import Checkbox from "@material-ui/core/Checkbox";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import axios from "axios";
import alertify from "alertifyjs";
import APIModel from "../../Models/APIModel";
import $ from "jquery";
import Loader from "react-loader-spinner";
import styled from "styled-components";
import { displayAlertifyError } from "../../util/functions";

const formList = [
  {
    id: 1,
    content: "California Preliminary 20-Day Notice",
    type: "data/form1",
    link: "",
  },
  {
    id: 2,
    content: "Conditional Waiver And Release On Final Payment",
    type: "data/form2",
    link: "",
  },
  {
    id: 3,
    content: "Conditional Waiver And Release On Progress Payment",
    type: "data/form3",
    link: "",
  },
  {
    id: 4,
    content: "Unconditional Waiver And Release On Final Payment",
    type: "data/form4",
    link: "",
  },
  {
    id: 5,
    content: "Unconditional Waiver And Release On Progress Payment",
    type: "data/form5",
    link: "",
  },
];

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
      margin: 0,
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: "25ch",
    },
    divider: {
      // Theme Color, or use css color in quote
      background: "#000",
    },
  })
);

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

function ListItemLink(props: ListItemProps<"a", { button?: true }>) {
  return <ListItem button component="a" {...props} />;
}

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

function SendForm() {
  const history = useHistory();
  const classes = useStyles();
  let get_token = localStorage.getItem("Token");
  let get_userid = localStorage.getItem("user_id");
  let user_status = localStorage.getItem("status");

  const [host, setHost] = useState(APIModel.HOST);
  const [token, setToken] = useState(get_token);
  const [userid, setUserId] = useState(get_userid);
  const [items, setItems] = useState([]);
  const [taxes, setTaxes] = useState([]);

  const [id, setId] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [price, setPrice] = useState("");
  const [note, setNote] = useState("");
  const [taxName, setTaxName] = useState("");
  const [percentage, setPercentage] = useState("");
  const [email, setEmail] = useState("");
  const [count, setCount] = useState(0);
  const [saveBtn, setSaveBtn] = useState(true);
  const [updateBtn, setUpdateBtn] = useState(false);
  const [selectedFile, setSelectedFile] = useState();
  const [loading, setLoading] = useState(true);

  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);

  const [search, setSearch] = useState("");
  const [foundItems, setFoundItems] = useState(items);
  const [noResult, setNoResult] = useState(false);

  const [taxInfo, setTaxInfo] = useState([]);

  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [checkboxes, setCheckbox] = useState({
    form1: false,
    form2: false,
    form3: false,
    form4: false,
    form5: false,
  });

  const filter = (event) => {
    setNoResult(true);
    const keyword = event;

    if (keyword !== "") {
      const results = items.filter((item) => {
        return item.name.toLowerCase().includes(keyword.toLowerCase());
        // Use the toLowerCase() method to make it case-insensitive
      });
      setFoundItems(results);
    } else {
      setFoundItems(items);
      // If the text field is empty, show all users
    }

    setSearch(keyword);
  };

  function allFilter() {
    setFoundItems(items);
  }

  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  function createForm() {
    const linkList = formList.filter((item) => {
      if (item.link !== "") return item.link;
    });

    let emailVal = $("#email").val();
    setEmail(emailVal);
    let params = {
      email: emailVal,
      forms: JSON.stringify(
        linkList.length === 0
          ? []
          : linkList.map((item) => {
              return item.link;
            })
      ),
    };

    if (emailVal === "" || emailVal === undefined) {
      displayAlertifyError({ error: "Please enter email" });
      return false;
    }
    if (linkList == "") {
      displayAlertifyError({ error: "Please select at least one form" });
      return false;
    }
    setDisabled(true);

    return axios
      .post(host + "send-form-client", params, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        setDisabled(false);
        if (response.data.status == true) {
          alertify.success(response.data.message);
          setCount(count + 1);
          $("#email").val("");
          setEmail("");
          setCheckbox({});
          setTimeout(() => {
            window.location.reload();
          }, 500);
        } else if (response.data.status == false) {
          displayAlertifyError({ error: response.data.message });
        }
      })
      .catch((response) => {
        console.log(response);
      });
  }

  const handleCheckboxes = (e, id) => {
    setCheckbox({ ...checkboxes, [`form${id}`]: e.target.checked });
    if (e.target.checked) {
      formList.forEach((item) => {
        if (item.id === id)
          item.link = `${APIModel.URL}${item.type}/${get_userid}`;
      });
    } else {
      formList.forEach((item) => {
        if (item.id === id) item.link = "";
      });
    }
    console.log(checkboxes);
  };

  if (token) {
    if (user_status === "user") {
      return <Redirect to="/payment"></Redirect>;
    } else {
      return (
        <div className="wrapper">
          <SideNav />
          <div className="main-panel">
            <div className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-12">
                        <div className="card">
                          <div className="card-body">
                            <form id="create_client">
                              <div className="row">
                                <Box
                                  fontSize={20}
                                  fontWeight="bold"
                                  ml={2}
                                  mb={5}
                                >
                                  Send Contract Forms
                                </Box>
                                <div className="col-12">
                                  <div className="form-group mb-0">
                                    <label className="mdc-floating-label--shake">
                                      Email
                                    </label>
                                    <input
                                      type="email"
                                      className="form-control input-box"
                                      id="email"
                                      name="email"
                                      required="required"
                                      autoFocus
                                    />
                                  </div>
                                </div>
                                <Box m={2} pb={2}>
                                  <Typography variant="h6">Contract</Typography>
                                  <DivContractCheckboxes>
                                    {formList.map((item) => {
                                      return (
                                        <>
                                          <div key={item.id} className="list">
                                            <div className="list-content">
                                              {item.content}
                                            </div>
                                            <div className="list-checkbox">
                                              {
                                                // clientData ? <a href={`${APIModel.URL}${item.type}/${get_userid}/${clientId}`} target="_blank">
                                                // <IconButton>
                                                //     <Visibility style={{color: '#9c27b0'}} />
                                                // </IconButton>
                                                // </a> : ''
                                              }
                                              <Checkbox
                                                onChange={(e) =>
                                                  handleCheckboxes(e, item.id)
                                                }
                                                checked={checkboxes[item.type]}
                                              />
                                            </div>
                                          </div>
                                          <Divider style={{ maxWidth: "" }} />
                                        </>
                                      );
                                    })}
                                    <br />
                                    <b>Note :</b> Check at least one
                                  </DivContractCheckboxes>
                                </Box>

                                <div className="col-12">
                                  <div className="form-group mb-">
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      onClick={() => {
                                        createForm();
                                      }}
                                      disabled={disabled}
                                    >
                                      {disabled ? "Sending..." : "Send Email"}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  } else {
    localStorage.setItem("route", "/send-lien-form");
    return <Redirect to="/"></Redirect>;
  }
}

export default SendForm;

const DivLoader = styled.div`
  text-align: center;
  margin: 30px 0px;
`;

const DivContractCheckboxes = styled.div`
  .list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // max-width: 500px;
    margin: 5px 0px;
    .list-content {
      //   max-width: 300px;
    }
    .list-checkbox {
      .css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.Mui-checked {
        color: #9c27b0;
      }
    }
  }
`;
